import React from 'react';
import { useTranslation } from 'react-i18next';

import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { productNames } from '@/hooks/use-active-product-name';
import { Product } from '@/hooks/use-jurisdiction';
import { AccountStackParamList } from '@/navigation/types';
import { toLocaleCurrency, toSocialCurrency } from '@/utils/numeric/currency';

import { AccountHistoryContent, AccountHistoryRow } from '../components/AccountHistoryContent';
import { PlayHistoryRange, usePlayHistory } from '../hooks/use-play-history';

type ScreenProps = NativeStackScreenProps<AccountStackParamList, 'PlayHistory'>;

export const PlayHistoryScreen = ({ route }: ScreenProps) => {
    const { product } = route.params;
    const { t } = useTranslation('account_summary');
    const isSocialWallet = product === Product.Sweeps || product === Product.Casino;
    const formatAmount = isSocialWallet ? toSocialCurrency : toLocaleCurrency;

    const useRows = (range: PlayHistoryRange) => {
        const { data, isLoading, isError } = usePlayHistory(range);
        const stats = data[product];
        const rows: AccountHistoryRow[] | undefined = stats && [
            { leftLabel: t('amount_played'), rightLabel: formatAmount(stats.amount_played) },
            { leftLabel: t('amount_played_bonus'), rightLabel: formatAmount(stats.amount_played_bonus) },
            { leftLabel: t('amount_won'), rightLabel: formatAmount(stats.amount_won) },
            { leftLabel: t('number_of_entries'), rightLabel: `${stats.number_of_bets}` },
        ];
        return { rows, isLoading, isError };
    };

    return (
        <AccountHistoryContent
            title={productNames[product] ?? t('play_history')}
            heading={t('play_history')}
            useRows={useRows}
        />
    );
};
